import {
  AUDIENCE_TYPES,
  AUDIENCE_TYPES_ARRAY,
  NARRATIVE_TYPES,
} from "posts/constants";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import CompareModal from "./CompareModal";
import styled from "styled-components";
import { COLORS, DEFAULT_BOX_SHADOW } from "utils/styles";
import { getAudienceEmoji } from "posts/constants";

const Wrapper = styled(Card)`
  ${DEFAULT_BOX_SHADOW};
  background: ${COLORS.WHITE};
  padding: 1rem 0.75rem;
  margin-bottom: 1rem;
`;

const Content = styled.div``;

const Title = styled.span.attrs(() => ({
  className: "mabry-medium",
}))`
  display: block;
  font-size: 1.125rem;
  margin-bottom: 1rem;
  font-weight: 500;
`;
const Description = styled.span`
  font-size: 0.875rem;
`;
const Icon = styled.i`
  transform: translateY(2px);
`;

function NarrativesCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);
  const [showNarrativeModal, setShowNarrativeModal] = useState(false);

  const getTitle = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return "Order";
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return "Authority";

      case AUDIENCE_TYPES.PEOPLE_POWER:
        return "Community";

      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return "Autonomy";
    }
  };

  const getDescription = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return "Playing by the rules is the key to success.";
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return "Strong leadership and hard work is the only solution.";
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return "All kinds of people coming together can fix the system.";
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return "There may be no one way to succeed, but freedom to make our own choices is paramount.";
    }
  };

  const renderContent = (audience) => {
    return (
      <Wrapper>
        <Content>
          <Title>{getTitle(audience)}</Title>
          <Description>{getDescription(audience)}</Description>
        </Content>
      </Wrapper>
    );
  };

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Main Value
      </CardTitle>
      {renderContent(activeAudience)}
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Values</CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`voices-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderContent(type, true)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default NarrativesCard;
